import React, { useState } from "react"
import { Form, Input, Button, Select, Tooltip, Icon } from "antd"

const { Option } = Select

const TopupAndPayoutForm = ({ service, checkAircashBarcode, getAircash, form }) => {
  const { getFieldDecorator, validateFields, getFieldValue } = form
  const [loading, setLoading] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [method, setMethod] = useState("barcode")
  const [rechargeMobile, setRechargeMobile] = useState(null)


  const handleCheckCode = (e) => {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
        checkAircashBarcode(
          service.service_id,
          method === "barcode" ? values.barcodeValue : values.digitCodeValue,
          setLoading,
          setRechargeMobile
        )
      }
    })
  }

  const handleConfirmTransaction = () => {
    if (rechargeMobile?.data) {
      getAircash(
        service.service_id,
        rechargeMobile?.data?.barCode,
        rechargeMobile?.data?.amount,
        setConfirmLoading
      )
    }
  }

  const isButtonDisabled = () => {
    if (!method) return true
    return !getFieldValue(method === "barcode" ? "barcodeValue" : "digitCodeValue")
  }

  return (
    <Form className="redeem-form" layout="vertical" onSubmit={handleCheckCode}>
      <p style={{ marginBottom: -3, fontWeight: "bold", fontSize: 15 }}>
        {rechargeMobile?.data
          ? "Conferma Transazione"
          : `Verifica ${method === "barcode" ? "Barcode" : "Digit Code"}`}
      </p>

      {!rechargeMobile?.data && (
        <Form.Item style={{ marginBottom: 0 }}>
          <Select
            className="aircash-method"
            placeholder="Metodo"
            onChange={setMethod}
            value={method}
          >
            <Option value="barcode">Usa Barcode</Option>
            <Option value="digitCode">Usa Digit Code</Option>
          </Select>
        </Form.Item>
      )}

      {!rechargeMobile?.data && method === "barcode" && (
        <Form.Item label="Scansiona Barcode">
          {getFieldDecorator("barcodeValue", {
            rules: [{ required: true, message: "Scansiona il codice a barre!" }],
          })(
            <Input
              placeholder="Scansiona barcode"
              suffix={<i className="fal fa-barcode-read" />}
            />
          )}
        </Form.Item>
      )}

      {!rechargeMobile?.data && method === "digitCode" && (
        <Form.Item label="Inserisci Digit Code">
          {getFieldDecorator("digitCodeValue", {
            rules: [{ required: true, message: "Inserisci il digit code!" }],
          })(
            <Input
              placeholder="Inserisci codice"
              suffix={
                <Tooltip title="Inserisci il codice ricevuto sulla ricevuta.">
                  <Icon type="info-circle" />
                </Tooltip>
              }
            />
          )}
        </Form.Item>
      )}

      {rechargeMobile?.data && (
        <>
          <Form.Item label="Barcode">
            <Input value={rechargeMobile?.data?.barCode} disabled />
          </Form.Item>
          <Form.Item label="Importo">
            <Input value={rechargeMobile?.data?.amount} disabled addonAfter="€" />
          </Form.Item>
        </>
      )}

      <Button
        type="primary"
        className="redeem-button"
        style={{ backgroundColor: service.colorBg, borderColor: service.colorBg }}
        loading={rechargeMobile?.data ? confirmLoading : loading}
        onClick={rechargeMobile?.data ? handleConfirmTransaction : handleCheckCode}
        disabled={isButtonDisabled()}
      >
        {rechargeMobile?.data ? "Conferma Deposito" : "Verifica Codice"}
      </Button>
    </Form>
  )
}

export default Form.create()(TopupAndPayoutForm)
